export default (invoiceId) =>
  `${process.env.REACT_APP_CHARGEBEE_URL}/d/invoices/${invoiceId}`;
